module.exports = {
  name: 'email', base: '_field', prototype: {
    element_selector: '.email input, input.email',
    valid: /^\S+@\S+\.\S{2,}$/
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/email.js
 ** module id = 15
 ** module chunks = 0
 **/